/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

import {
  Row,
  Col,
  Breadcrumb,
  List,
  Avatar,
  Typography,
  Modal,
  message,
} from "antd";

import { UserOutlined } from "@ant-design/icons";

import { NavLink, Link } from "react-router-dom";
import styled from "styled-components";
import avtar from "../../assets/images/team-2.jpg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: #1890ff;
  }
  .ant-btn-success {
    background-color: #52c41a;
  }
  .ant-btn-yellow {
    background-color: #fadb14;
  }
  .ant-btn-black {
    background-color: #262626;
    color: #fff;
    border: 0px;
    border-radius: 5px;
  }
  .ant-switch-active {
    background-color: #1890ff;
  }
`;

function Header({ name, subName }) {
  const userId = localStorage.getItem("userId");
  const history = useHistory();
  const { Title, Text } = Typography;

  const [visible, setVisible] = useState(false);
  const [sidenavType, setSidenavType] = useState("transparent");

  useEffect(() => window.scrollTo(0, 0));

  const showDrawer = () => setVisible(true);
  const hideDrawer = () => setVisible(false);

  const handleSignOut = async () => {
    localStorage.removeItem("userId");
    message.success("Logout successfully");

    history.push("/dashboard");
    window.location.reload();
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Pages</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ textTransform: "capitalize" }}>
              {name.replace("/", "")}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "capitalize" }}
            >
              {subName.replace("/", "")}
            </span>
          </div>
        </Col>
        <Modal
          title="Confirm Sign Out"
          visible={isModalVisible}
          onOk={handleSignOut}
          onCancel={handleCancel}
          okText="Sign Out"
          okType="danger"
          cancelText="Cancel"
        >
          <p>Are you sure you want to sign out?</p>
        </Modal>
        <Col span={24} md={18} className="header-control">
          {!userId && (
            <div style={{ display: "flex", gap: 12 }}>
              <Link to="/sign-in" className="btn-sign-in">
                <span style={{ color: "black" }}>
                  <UserOutlined /> Sign in
                </span>
              </Link>
              <Link to="/sign-up" className="btn-sign-in">
                <span style={{ color: "black" }}>
                  <UserOutlined /> Sign up
                </span>
              </Link>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}

export default Header;
